// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1y27t"};